import React from "react";
import Container from "../common/Container";
import Button from "../common/Button";
import {
  Code2,
  Cloud,
  Brain,
  Smartphone,
  ArrowRight,
} from "lucide-react";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-white">
      {/* Background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-blue-50 via-white to-indigo-50" />

      <Container size="lg" className="py-36">
        <div className="grid lg:grid-cols-2 gap-24 items-center">
          
          {/* LEFT CONTENT */}
          <div>
            <p className="text-sm font-semibold tracking-wide text-blue-600 uppercase">
              Brightly LLC · Software Engineering
            </p>

            <h1 className="mt-6 text-5xl sm:text-6xl font-extrabold tracking-tight text-slate-900 leading-tight">
              We engineer software
              <span className="block text-blue-600">
                built to scale and last
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-lg text-slate-600 leading-relaxed">
              Brightly LLC is a full-stack software development company helping
              startups and growing businesses design, build, and maintain
              reliable digital products across web, mobile, cloud, and AI.
            </p>

            <div className="mt-12 flex flex-wrap items-center gap-5">
              <Button size="lg" variant="outline">
                <a href="/services" className="flex items-center gap-2">
                View Our Services
                </a>
              </Button>
            </div>

            <div className="mt-12 text-sm text-slate-500">
              Web Applications • Mobile Platforms • Cloud Infrastructure • AI Systems
            </div>
          </div>

          {/* RIGHT VISUAL */}
          <div className="relative hidden lg:block">
            <div className="grid grid-cols-2 gap-6">
              {[
                {
                  icon: Code2,
                  title: "Web Applications",
                  desc: "Scalable, secure platforms",
                },
                {
                  icon: Smartphone,
                  title: "Mobile Development",
                  desc: "iOS & Android solutions",
                },
                {
                  icon: Brain,
                  title: "AI & Automation",
                  desc: "Data-driven intelligence",
                },
                {
                  icon: Cloud,
                  title: "Cloud & DevOps",
                  desc: "Reliable infrastructure",
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100 text-blue-600">
                    <item.icon size={24} />
                  </div>

                  <h3 className="mt-4 font-semibold text-slate-900">
                    {item.title}
                  </h3>
                  <p className="mt-1 text-sm text-slate-600">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>

            {/* Accent */}
            <div className="absolute -top-12 -right-12 h-36 w-36 rounded-full bg-blue-200 blur-3xl opacity-60" />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
